import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useUpdateCushionChargePolicyMutation } from 'queries/company'
import { useCompanyDetailContextValue } from 'pages/Company/CompanyDetail/context/CompanyDetailProvider'

type EditCushionChargePolicyFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useUpdateCushionChargePolicyMutation>['mutate']
    reset: ReturnType<typeof useUpdateCushionChargePolicyMutation>['reset']
  }
}

const [Context, useEditCushionChargePolicyFlowContextValue] =
  createContext<EditCushionChargePolicyFlowContextState>({
    name: 'EditCushionChargePolicyFlowContext',
  })

export const EditCushionChargePolicyFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: companyId },
  } = useCompanyDetailContextValue()
  const { mutate, reset, isPending, isError, error } =
    useUpdateCushionChargePolicyMutation(companyId)

  const value: EditCushionChargePolicyFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: isError ? parseErrorMessage(error) : undefined,
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditCushionChargePolicyFlowContextValue }
